let ua: UACaps = {
	supportStreaming: false
}

export interface UACaps {
	supportStreaming: boolean;
}

export function detectUA(context: Window): UACaps {
	let webGLCanvas = context.document.createElement('canvas')
	let webGLContext = webGLCanvas.getContext('webgl') || webGLCanvas.getContext('experimental-webgl')
	let supportWebGL = !!webGLContext
	let notIE = !(~context.navigator.userAgent.indexOf('MSIE') || ~context.navigator.userAgent.indexOf('Trident/'))
	
	ua.supportStreaming = supportWebGL && notIE
	return ua
}


// WEBPACK FOOTER //
// ./base/useragent-detect.ts